module.exports = __webpack_public_path__ + "static/media/concave.a0d375db.svg";